import http from './http.service';

class PublicSpecialOfferService {
    constructor() {
        if (PublicSpecialOfferService.instance) {
            return PublicSpecialOfferService.instance;
        }

        PublicSpecialOfferService.instance = this;
    }

    getSpecialOffers() {
        return http.get('/public-offer').then(res => res.data);
    }

    getSpecialOffer(slug) {
        return http.get(`/public-offer/${slug}/show`).then(res => res.data);
    }
}

export default new PublicSpecialOfferService();
